import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$slug/events")({
  component: Events,
});

function Events() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-primary-darker">Events</h1>
      <p className="mt-2 text-gray-500">Plan and track events.</p>
    </div>
  );
}
